import { useAppDispatch, useAppSelector } from "app.hook";
import * as React from "react";
import { shallowEqual } from "react-redux";
import { Link } from "react-router-dom";
import {
  ACCOUNT_EDIT_ROUTE,
  BILLING_ADDRESS_ROUTE,
  ORDER_ROUTE,
  SHIPPING_ADDRESS_ROUTE,
} from "shared/constants/routes";
import { selectCurrentCustomer } from "states/customer/customer.slice";
import {
  selectActiveMenu,
  setSignOut,
} from "states/global-value/global-value.slice";
import {
  IconAddress,
  IconArrowRight,
  IconBilling,
  IconInvoice,
  IconSignOut,
  IconUser,
} from "themes/icons";
import { FlexAuto,  } from "themes/style-components/flex";
import { Aside, AvatarContainer } from "./style/sidebar-style";
export interface ISidebarProps {}

export const Sidebar = (props: ISidebarProps) => {
  const currentCustomer = useAppSelector(selectCurrentCustomer, shallowEqual);
  const activeMenu = useAppSelector(selectActiveMenu, shallowEqual);
  const dispatch = useAppDispatch();
  const handleActiveMenu = (active: string) => activeMenu === active ? "active" : "";
  return (
    <Aside>
      <AvatarContainer>
        <div className="avatar">
          {currentCustomer?.firstName?.charAt(0)}
        </div>
        <FlexAuto>
          <div className="info">
            <p>Account of</p>
            <p>
              {`${currentCustomer.firstName} ${currentCustomer.lastName}`.toUpperCase()}
            </p>
          </div>
        </FlexAuto>
      </AvatarContainer>
      <ul>
        <li className={handleActiveMenu("user")}>
          <Link aria-label="Click redirect to user info" to={ACCOUNT_EDIT_ROUTE}>
            <IconUser className="icon__left" width={20} />
            <span>User Info</span>
          </Link>
          <IconArrowRight className="arrow__right" width={20} />
        </li>
        <li className={handleActiveMenu("order")}>
          <Link aria-label="Click redirect to order page" to={ORDER_ROUTE}>
            <IconInvoice className="icon__left" width={20} />
            <span>Orders</span>
          </Link>
          <IconArrowRight className="arrow__right" width={20} />
        </li>
        <li className={handleActiveMenu("billing")}>
          <Link to={BILLING_ADDRESS_ROUTE}>
            <IconBilling className="icon__left" width={20} />
            <span>Billing Address</span>
          </Link>
          <IconArrowRight className="arrow__right" width={20} />
        </li>
        <li className={handleActiveMenu("shipping")}>
          <Link aria-label="Click redirect to shipping address page" to={SHIPPING_ADDRESS_ROUTE}>
            <IconAddress className="icon__left" width={20} />
            <span>Shipping Address</span>
          </Link>
          <IconArrowRight className="arrow__right" width={20} />
        </li>
        <li className={handleActiveMenu("logout")}>
          <button
            aria-label="Click to sign out"
            onClick={() => {
              dispatch(setSignOut());
            }}
          >
            <IconSignOut className="icon__left" width={20} />
            <span>Sign out</span>
          </button>
          <IconArrowRight className="arrow__right" width={20} />
        </li>
      </ul>
    </Aside>
  );
};
export default Sidebar;
